import { useEffect, useRef, useState } from "react";

const Visualizersm = ({ disabled }) => {
  const canvasRef = useRef(null);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const dataArrayRef = useRef(null);
  const streamRef = useRef(null);
  const animFrameRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const [hasMicPermission, setHasMicPermission] = useState(true);

  const draw = () => {
    if (!canvasRef.current || !analyserRef.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const { width, height } = canvas;
    ctx.clearRect(0, 0, width, height);

    analyserRef.current.getByteFrequencyData(dataArrayRef.current);
    const barWidth = width / dataArrayRef.current.length;

    ctx.fillStyle = "#4B5563";
    dataArrayRef.current.forEach((value, i) => {
      const barHeight = (value / 445) * height;
      ctx.fillRect(i * barWidth, height - barHeight, barWidth - 2, barHeight);
    });

    animFrameRef.current = requestAnimationFrame(draw);
  };

  const startAudio = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current = stream;
      audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
      const source = audioContextRef.current.createMediaStreamSource(stream);
      analyserRef.current = audioContextRef.current.createAnalyser();
      analyserRef.current.fftSize = 32;
      dataArrayRef.current = new Uint8Array(analyserRef.current.frequencyBinCount);
      source.connect(analyserRef.current);
      setIsActive(true);
      draw();
    } catch (err) {
      console.error("Microphone access denied:", err);
      setHasMicPermission(false);
    }
  };

  const stopAudio = () => {
    if (animFrameRef.current) {
      cancelAnimationFrame(animFrameRef.current);
      animFrameRef.current = null;
    }
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
    if (audioContextRef.current) {
      audioContextRef.current.close();
      audioContextRef.current = null;
    }
    analyserRef.current = null;
    dataArrayRef.current = null;
    setIsActive(false);
  };

  // Clean up on unmount
  useEffect(() => {
    return () => {
      stopAudio();
    };
  }, []);

  const handleToggle = () => {
    if (disabled) return;
    if (isActive) {
      stopAudio();
    } else {
      startAudio();
    }
  };

  if (!hasMicPermission) return null;

  return (
    <div></div>

  );
};
    // <div
    //   onClick={handleToggle}
    //   className="cursor-pointer flex items-center gap-2"
    //   title={isActive ? "Stop mic test" : "Click to test microphone"}
    // >
    //   {isActive ? (
    //     <canvas
    //       ref={canvasRef}
    //       width={150}
    //       height={40}
    //       className="transition-all duration-300"
    //     />
    //   ) : (
    //     <div className="w-[150px] h-[40px] rounded-md border border-dashed border-gray-400 flex items-center justify-center text-xs text-gray-500 hover:border-gray-600 hover:text-gray-700 transition-colors">
    //       🎤 Tap to test
    //     </div>
    //   )}
    // </div>

export default Visualizersm;
